/**
 * HOC withRequiredRoles
 * Protege a renderização de um componente com base nas roles do usuário atual.
 * Preserva propriedades estáticas (como `reduxAsyncConnect`) para que o SSR
 * do Volto (`loadOnServer`) consiga descobrir os itens assíncronos definidos
 * no componente envolvido.
 */
import React from 'react';
import Unauthorized from '@plone/volto/components/theme/Unauthorized/Unauthorized';
import { userHasRoles } from '@plone/volto/helpers/User/User';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { connect } from 'react-redux';

export default function withRequiredRoles(WrappedComponent, roles = []) {
  class RequiredRoles extends React.Component {
    render() {
      // Nega o acesso quando não há roles especificadas ou o usuário
      // não possui as roles requeridas
      if (roles.length === 0 || !userHasRoles(this.props.user, roles)) {
        return <Unauthorized />;
      }

      return <WrappedComponent {...this.props} />;
    }
  }

  const mapStateToProps = (state) => ({
    user: state.users.user,
  });

  const Connected = connect(mapStateToProps)(RequiredRoles);

  // Copia estatics não-React (ex.: reduxAsyncConnect) do componente original
  // para o wrapper conectado, permitindo que o SSR encontre os itens assíncronos.
  hoistNonReactStatics(Connected, WrappedComponent);

  return Connected;
}
